import {ServiceTypeSelectorProps, serviceTypesSelector, useGetAllServiceTypesQuery} from "@ots-frontend/ots-data";
import {BaseServiceTypeSelect, BaseServiceTypeSelectProps} from "./BaseServiceTypeSelect";
import {useMemo} from "react";

export type ServiceTypeSelectProps = Omit<BaseServiceTypeSelectProps, "entities" | "loading"> & {
  selector?: ServiceTypeSelectorProps
}

export const ServiceTypeSelect = (props: ServiceTypeSelectProps) => {
  const {selector, ...rest} = props;

  const selectServiceTypes = useMemo(() => {
    return serviceTypesSelector();
  }, []);

  const {serviceTypes, isLoading} = useGetAllServiceTypesQuery(selector?.regionId, {
    selectFromResult: (result) => ({
      serviceTypes: selectServiceTypes(result, selector),
      isLoading: result.isLoading
    })
  });

  return <BaseServiceTypeSelect entities={serviceTypes} loading={isLoading} {...rest} />;
};
